import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import { Table, FormGroup, Label, Input } from 'reactstrap';
import DropdownLayout from './DropdownLayout';
import Pagination from 'react-ultimate-pagination-material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import $ from 'jquery';
import GetCheckBox from './GetCheckBox';
import HmEventRegistry from '../../model/HmEventRegistry';

export default class AdminLayout extends LoggedInPage{

    constructor(props){
        super(props)
        this.state={
            dropdownOpen: false,
            dataLoaded:true,
            data:null,
            currentScrollIndex: 1,
            paginationDisabled:false,
            initialLoop:1,
            totalSelected:0,
            checkedAll:false
        }
        this.getHeader = this.getHeader.bind(this);
        this.getRowsData = this.getRowsData.bind(this);
        this.getSelectedCount = this.getSelectedCount.bind(this);
        this.getKeys = this.getKeys.bind(this);
        this.checkAllFn = this.checkAllFn.bind(this);
        this.toggle = this.toggle.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.checkUnCheckUsers = this.checkUnCheckUsers.bind(this);
        this.userNameHover = this.userNameHover.bind(this);

        this.questionTypeCount = 0;

        this.paginationLoopCnt = 10;
        this.paginationPerPage = 0;
        this.tableData = props.data || null;        

        this.userIdIndexMap = {};
        this.checkedUserIds = new Set();
    }

    getCount(forceLoad=false){
        if(typeof this.props.getCount === "function"){
            this.props.getCount(forceLoad);
        }
    }

    checkUnCheckUsers(tableRowData, inputElem){
        
        try{
            if(tableRowData && tableRowData.userId){
                const prevState = this.tableData.data[this.userIdIndexMap[tableRowData.userId]].checked || false;
                this.tableData.data[this.userIdIndexMap[tableRowData.userId]].checked = !(prevState);
                inputElem.checked = !(prevState);
            }
        }catch(e){
            console.error("lalala ::" , e);
        }
        //console.log("lalala", tableRowData);
    }

    checkAllFn(checkVal){
        (this.tableData.data).map((data,index)=>{
            //console.log("checkAllFn ",data);
            data.checked = checkVal;
        })
        this.getSelectedCount();
        this.setState({checkedAll:checkVal});
    }

    getSelectedCount(){
        let me=this;
        if(typeof this.props.getuserList==="function"){
            //console.log("totalSelected ::" , me.props.getuserList());
            me.setState({totalSelected:me.props.getuserList()});
        }
    }

    userNameHover(){
        let me=this;
        setTimeout(function(){	
            let tooltipArr = me.tableData.toolTipArr || [];
            for(let i=0;i<tooltipArr.length;i++){
                if($("#AdminPanelLayout .admlayindex"+tooltipArr[i]).hasClass("tooltipcss")){
                     $("#AdminPanelLayout .admlayindex"+tooltipArr[i]).removeClass("tooltipcss");
                };
                $("#AdminPanelLayout .admlayindex"+tooltipArr[i]).addClass("tooltipcss");
                $("#AdminPanelLayout .admlayindex"+tooltipArr[i]).css("cursor","pointer");
                $("#AdminPanelLayout .admlayindex"+tooltipArr[i]).off('mouseenter');
                $("#AdminPanelLayout .admlayindex"+tooltipArr[i]).on('mouseenter', function () {
                var $this = $(this);
                        $this.tooltip({
                            title: $(this).text(),
                            placement: "top"
                        });
                        $this.tooltip('show');                
                });
            }
         },100);
    }

    componentDidMount(){
        let me=this;
        
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");  

        if(this.tableData && this.tableData.data && this.tableData.data.length>0){
            this.questionTypeCount =  this.tableData.data.length;
            this.paginationLoopCnt = this.tableData.pagePerPage || this.paginationLoopCnt;
            this.paginationPerPage = Math.ceil(this.questionTypeCount / this.paginationLoopCnt);
            this.setState({data:this.tableData});
            this.userNameHover()
        }
    }
    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    getKeys(){
        let tableData = this.tableData || {};
        return Object.keys(tableData.data[0]);
    }

    getHeader(){
        let tableData = this.tableData || {};
        let keys = this.getKeys();
        let headerForAll = keys || [];
        let userFeature = tableData.userFeature!=null ?  Object.values(tableData.userFeature) : {};

        if(userFeature.length>0){
            for(let i=0;i<userFeature.length;i++){
                let headerLeng =  (headerForAll.length >0) ?  headerForAll.length : 0;
                let userFeaLeng =  (userFeature.length >0) ?  userFeature.length : 0;
                let totLeng = headerLeng + userFeaLeng;
                let order  = (userFeature[i].order >=0 && userFeature[i].order < totLeng) ? userFeature[i].order : 0;
                headerForAll.splice(order,0,"_feature"+userFeature[i].name);
            }
        }

        let insertFilter = tableData.filters || [];
        let contesttype = (this.tableData && this.tableData.contestType) ? this.tableData.contestType :"ALL";
        let hiddenData = window.hidden_table_header[contesttype]  || [];
        //Rows data
        let items = tableData.data || [];
        
        return headerForAll.map((key, index)=>{
            let headerShow = (key && ~(hiddenData).indexOf(key));
             //console.log("insertFilter ",insertFilter," : ",insertFilter.sort());
             if(!(key.match("_feature")>-1)) {
                return <th key={key}></th>
            } else if(this.setFilter(key,insertFilter)){
               return (
               <th key={key}>{key}<DropdownLayout data={this.getDropdownArray(items,key)}></DropdownLayout></th>
               );
           } else if(headerShow){
               return <th key={key}>{key}</th>
           }

       }) 
    }


    getDropdownArray(items,key){
        let data = [];
        items.map((row, index)=>{
            data.push(row[key]);
        })

        let optionList = new Set();

        for(let i=0;i<data.length;i++){
            optionList.add(data[i])
        }

        let myArr = Array.from(optionList);
        return myArr.sort();
    }

    setFilter(filterkey,in_Filter){
      let filterFeature = [];
      filterFeature = in_Filter;
      if(filterkey && filterFeature){
        for(let i in filterFeature){
                    //console.log("filterkey",filterkey, ":", filterFeature[i]);
                    if(filterkey.match(filterFeature[i])){
                        //return true;
                        return false;
                    }
                }
            }
            return false;
        }

        getDataObjectsFn(){
            let retarr = [];
            
            let tableData = this.tableData || {};
            let items = tableData.data || [];
            let loopcnt = 0;
            var me=this;
            let page  = this.state.initialLoop;
            let start = ((page * me.paginationLoopCnt) - me.paginationLoopCnt);
       // console.log("getDataObjectsFn ",items);
       if(start < (items.length)){
        for(let i=start;i<items.length;i++){
         if(loopcnt < me.paginationLoopCnt){
               // console.log("Loop ",start," : ",items[i]);
               retarr.push(items[i])
               loopcnt++;
           }else{
             break;
         }
     }
     return retarr;
 }

}

getRowsData(){
    let me = this;
     
    let tableData = this.tableData || {};
        let items = tableData.data || []; // this.getDataObjectsFn() || [];
        //console.log("items ",this.totalUserCnt)
        let keys = this.getKeys() || [];
        let userFeature = tableData.userFeature!=null ?  Object.values(tableData.userFeature) : {};
        let featureOrder = tableData.userFeatureOrder!=null ?  Object.values(tableData.userFeatureOrder) : [];
        
        if(userFeature.length>0){
            for(let i=0;i<userFeature.length;i++){
                featureOrder[userFeature[i].name] = i;
                let keysLeng =  (keys.length >0) ?  keys.length : 0;
                let userFeaLeng =  (userFeature.length >0) ?  userFeature.length : 0;
                let totLeng = keysLeng + userFeaLeng;
                let order  = (userFeature[i].order >= 0 && userFeature[i].order < totLeng) ? userFeature[i].order : 0;
                keys.splice(order,0,userFeature[i].name);
                //console.log("getKeys ",items, " : ",userFeature[i].order);
            }
        }

        let startIndex = ((this.state.initialLoop - 1 || 0) * this.paginationLoopCnt);
        let endIndex = startIndex + this.paginationLoopCnt;
        //console.log("started ",new Date().getSeconds());
        return items.map((row, index)=>{
            try{
                this.userIdIndexMap[row.userId] = index;
            }catch(e){
                console.error(e);
            }

            if(row.checked){
              //  console.log("lalalala :: ", row, row.checked);
            }
          let paginationShow = this.tableData.pagination || false;
          if(!paginationShow || (index >= startIndex && index < endIndex)){
            let styles = (row.duplicate) ? 'duplicateData' : '';
           
            return (
                <tr key={index} className={styles}>
                <RenderRow tableData={this.tableData} checkedAll={this.state.checkedAll} userListCount={this.getSelectedCount} checkUnCheckUsers={this.checkUnCheckUsers} key={index} userFeature={userFeature} featureOrder={featureOrder} rowdata={row} keys={keys} toggle={this.toggle} dropdownOpen={this.state.dropdownOpen} />
                </tr>
                )
            }else if(index > endIndex){
                //break;
            } 

        })
    } 

    getDuplicateCount(items){
        let me = this;
        let totalUserCnt = items.length || 0;
        let duplicateCnt = 0;

        items.map((row, index)=>{
          let styles = (row.duplicate) ? 'duplicateData' : '';
          if(styles==="duplicateData"){
            duplicateCnt++;
        }
    })
    //console.log("duplicateData ",duplicateCnt," : ",totalUserCnt);
    return ({duplicateCnt:duplicateCnt,totalUserCnt:totalUserCnt});
}

renderSelectedCount(){
    let userListCount = this.state.totalSelected || 0;
    let totalTableDataCount = (this.tableData && this.tableData.data) ? (this.tableData.data).length : 0;
    //console.log("SelectedCount ",userListCount," : ",totalTableDataCount);
    if(totalTableDataCount>0 && userListCount>0){
        //Selected out of {totalTableDataCount}
        return(
            <div className="selected_msg">Selected : <span>{userListCount}</span> </div>
        )
    }
}

getBottomData(){
    let totalTableDataCount = (this.tableData && this.tableData.data) ? (this.tableData.data).length : 0;
    if(totalTableDataCount>0){
        let startIndex = ((this.state.initialLoop - 1 || 0) * this.paginationLoopCnt)+1;
        let endIndex = this.state.initialLoop * this.paginationLoopCnt;
        if(endIndex>totalTableDataCount){
            endIndex = totalTableDataCount;
        }
        return(
            <div className="tabledatainfo">
                {this.rb(("contest.pages.info"),[startIndex,endIndex,totalTableDataCount])}
            </div>
        )   
    }
}

renderDuplicateLogin(){
     
    let tableData = this.tableData|| {};
    let items = tableData.data || [];
    let duplicateData = null;
    duplicateData = this.getDuplicateCount(items);

    if(duplicateData){
        if(duplicateData.duplicateCnt && duplicateData.duplicateCnt>0){
            return(
                <div className="duplicate_msg">{duplicateData.duplicateCnt} Duplicate Registration out of {duplicateData.totalUserCnt}</div>
                )
            }
        }
    }

    onPageChange(page){
        this.changeEvent(page);				
           this.userNameHover();
        
    }

    changeEvent(page){
      this.setState({initialLoop:page});
      this.getDataObjectsFn(this.initialLoop);
     
      
  }

  render(){
   if(!this.state.dataLoaded){
    return super.render()
}else{ 
    return(
    <div>
    <MuiThemeProvider>
    <div id="AdminPanelLayout">
    <div className="clearfix"></div>
    {
            this.renderSelectedCount()
        }
        {
            
            this.renderDuplicateLogin()
        }
    <Table responsive="md">

    <thead>                           
    <tr>{this.getHeader()}</tr>
    </thead>
    <tbody>                            
    {this.getRowsData()}
    </tbody>

    </Table>
    {
        (()=>{
         let paginationShow = this.tableData.pagination || false;
         if(paginationShow && this.questionTypeCount > 0){
            return (
            <div className="col-12 text-center paginationParent adminpagination">

            <div className="float-left bottomshowdata">
            {this.getBottomData()}
                </div>

            <div className="float-right pageshowdata">
            <Pagination
            currentPage={this.state.initialLoop}
            totalPages={this.paginationPerPage}
            boundaryPagesRange={1}
            siblingPagesRange={1}
            hidePreviousAndNextPageLinks={false}
            hideFirstAndLastPageLinks={false}
            hideEllipsis={false}
            onChange={this.onPageChange}
            disabled={this.state.paginationDisabled}
            />
                </div>
            </div>
            )
        }
    })()
}
</div>
</MuiThemeProvider>
</div>
)
}
}
}



const RenderRow = (props) =>{
    let tableData = (props.tableData);
    let contesttype = (tableData && tableData.contestType) ? tableData.contestType :"ALL";
    let hiddenData = window.hidden_table_data_col[contesttype]  || [];
    return props.keys.map((data, index) => {
        let me = this; 
        let feature = false;
        var featureOrder = props.featureOrder || [];
        var cnt=0;

        for(var i=0;i<featureOrder.length;i++){
            if(index==featureOrder[i]){
                feature=true;
                cnt=i;
                break;
            }
        }

            let event = '';
            let eventAllow = "";

            if(feature){
                event = (typeof props.userFeature[cnt]==="object") ? props.userFeature[cnt].clickEvent : ''; 
                eventAllow = (typeof props.userFeature[cnt]==="object") ? (props.userFeature[cnt].active) || false : false; 
            }

            switch(data){
                case "checkbox":  
                return (<td key={index} className={"admlayindex"+index}>
                <GetCheckBox active={eventAllow} callBack={event} userdata={props.rowdata}{...props}/>
                </td> )
                break;
                case "star": 
                return (<td key={index} className={"admlayindex"+index}>
                <GetStar active={eventAllow} callBack={event} userdata={props.rowdata} {...props}/>
                </td>)
                break;
                case "edit": 
                return (<td key={index} className={"admlayindex"+index}>
                <GetEdit active={eventAllow} callBack={event} userdata={props.rowdata} {...props}/>
                </td>)
                break;
                case "more": 
                let menuList = (typeof props.userFeature[cnt]==="object") ? (props.userFeature[cnt].menuList) || [] : []; 
                return (<td key={index} className={"admlayindex"+index}>
                <GetMore menuList={menuList} active={eventAllow} callBack={event} userdata={props.rowdata} {...props}/>
                </td>)
                break;
                default:
                
                let colomshow = (data && ~hiddenData.indexOf(data.toLowerCase()));
                //console.log("bott "+~hiddenData.indexOf(data.toLowerCase()));
                if(!colomshow){
                    return (
                    <td key={index} className={"admlayindex"+index} data-toggle="tooltip">
                    {
                        (()=>{
                            if(props.rowdata[data] === undefined){
                                return "--";   
                            }
                            else if(props.rowdata[data] == "null" || props.rowdata[data] == "Null" || (props.rowdata[data]).length< 1){
                                return "--";   
                            }
                            return props.rowdata[data];   
                        })()
                    }
                    </td>
                    )  
                }
            }
        })
    }



    const GetStar = (props) =>{
        let active = (props.active) ? "" : " disabled";
        return(
        <div className={"RegFunc singleCheck"+active} 
        onClick={(()=>{
            //console.log("clicked admin");
            if(typeof props.callBack==="function"){
                props.callBack.apply(this,[props.userdata]);
            };
        })}>
        <div className="starSelect">
        <FormGroup check>                            
        <Input className="star" type="checkbox" /><Label check>
        </Label>
        </FormGroup>
        </div>
        </div>
        );
    } 

    const GetMore = (props) =>{
        //console.log("props menuList",props.menuList);
        let active = (props.active) ? "" : " disabled";
        let moreChoice = props.menuList || [];

        let eventClick = function(value){
            if(typeof props.callBack==="function"){
                let userdata =  props.userdata || [];
                let userinfo = {
                    "userdata":userdata,
                    "value":value
                };
                props.callBack.apply(this,[userinfo]);
            };
        };

        return(
            <div className="RegFunc singleCheck">
            <div className={"moreButton more-opt"+active}>
            <DropdownLayout tick={false} data={moreChoice} event={eventClick} icon={"more_vert"} > </DropdownLayout>
            </div>
            </div>
            );
        }
        const GetEdit = (props) =>{
            let active = (props.active) ? "" : " disabled";
            return(
            <div className="RegFunc singleCheck">
            <div className={"moreButton"+ active} data-ga="Student Edit" onClick={(()=>{
                //console.log("clicked admin ",props.callBack);
                if(typeof props.callBack==="function"){
                    //console.log("clicked callback");
                    props.callBack.apply(this,[props.userdata]);
                };
            })}>
            <i className="material-icons">edit</i>
            </div>
            </div>

            );
        }



// WEBPACK FOOTER //
// ./src/views/registration/AdminLayout.js